import React, { useState, useRef, useEffect, useImperativeHandle } from "react";
import { Input, Dropdown, SuperButton } from "../../elements";
import { S_LANG, webStorage } from "../../utils/webStorage";
import api from "../../utils/api";
import { isBizNull } from "../../utils";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import { getCountryOptions, isLoggedIn } from "../../services/siteService";
import { isGlobalSite } from "../../utils/siteUtils";
import { addressTypes } from "../../utils/lynkco-constants";
import getSiteInfo from "../../utils/getSiteInfo";

const PreSalesBillingInfoForm = React.forwardRef((props, ref) => {
  const { fields, isDisabled, address, savable = true, onSaveSuccess, user } = props;
  const {
    firstNameLabel,
    firstNameMissingMessage,
    lastNameLabel,
    lastNameMissingMessage,
    // emailLabel,
    // emailMissingMessage,
    // emailWarningMessage,
    // phoneAreaLabel,
    // phoneAreaMissingMessage,
    // phoneLabel,
    // phoneMissingMessage,
    // phoneWarningMessage,
    streetLabel,
    streetMissingMessage,
    apartmentLabel,
    postalCodeLabel,
    postalCodeMissingMessage,
    postalCodeWarningMessage,
    cityLabel,
    cityMissingMessage,
    countryLabel,
    countryPrivateImportMessage,
    // addressMissingMessage,
    // addressUnsavedMessage,
    ctaName,
    ctaType,
    colorScheme,
    iconName
  } = fields;
  const lang = webStorage.get(S_LANG);
  const [siteInfo, setSiteInfo] = useState({});
  // const [areaCodeList, setAreaCodeList] = useState([]);
  const [firstName, setFirstName] = useState(address?.firstName);
  const [firstNameError, setFirstNameError] = useState(null);
  const [lastName, setLastName] = useState(address?.lastName);
  const [lastNameError, setLastNameError] = useState(null);
  // const [email, setEmail] = useState("");
  // const [emailIsValid, setEmailIsValid] = useState(null);
  // const [emailError, setEmailError] = useState(null);
  // const [phoneArea, setPhoneArea] = useState("");
  // const [phoneAreaIsValid, setPhoneAreaIsValid] = useState(true);
  // const [phoneAreaError, setPhoneAreaError] = useState(null);
  // const [phone, setPhone] = useState("");
  // const [phoneIsValid, setPhoneIsValid] = useState(true);
  // const [phoneError, setPhoneError] = useState(null);
  const [street, setStreet] = useState(address?.street);
  const [streetError, setStreetError] = useState(null);
  const [apartment, setApartment] = useState(address?.apartment);
  const [apartmentError, setApartmentError] = useState(null);
  const [postalCode, setPostalCode] = useState(address?.postalCode);
  const [postalCodeError, setPostalCodeError] = useState(null);
  const [postalCodeIsValid, setPostalCodeIsValid] = useState(true);
  const [city, setCity] = useState(address?.city);
  const [cityError, setCityError] = useState(null);
  const [country, setCountry] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [formError, setFormError] = useState(null);
  const [countries, setCountries] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [countryPrivateImportMsgShow, setCountryPrivateImportMsgShow] = useState(false);
  const rootEl = useRef();
  useEffect(() => {
    init();
  }, []);
  useEffect(() => {
    setFirstName(address?.firstName);
    setLastName(address?.lastName);
    setStreet(address?.street);
    setApartment(address?.apartment);
    setPostalCode(address?.postalCode);
    setCity(address?.city);
  }, [address]);
  useEffect(() => {
    let country = countries.find(x => x.data.regionAbbr === address?.countryCode);
    if (!country) {
      if (!isGlobalSite()) {
        country = countries.find(c => c.code === siteInfo.country);
      }
    }
    setCountry(country);
  }, [address, countries]);
  useImperativeHandle(ref, () => ({
    setError(error) {
      setFormError(error);
    },
    validateForm() {
      return {
        isValid: validateFields(),
        formData: {
          firstName,
          lastName,
          // email,
          // phoneArea,
          // phone,
          street,
          apartment,
          postalCode,
          city,
          countryId: country.code,
          country: country.value,
          countryCode: country.data.regionAbbr,
          unSave: true
        }
      };
    },
    getEl() {
      return rootEl.current;
    }
  }));
  const init = async () => {
    const countries = await getCountryOptions();
    setCountries(countries);
    if (!isGlobalSite()) {
      const siteInfo = await getSiteInfo();
      setSiteInfo(siteInfo);
      const country = countries.find(c => c.code === siteInfo.country);
      setCountry(country);
    }
  };
  const validateFields = () => {
    let valid = true;
    if (isBizNull(firstName)) {
      setFirstNameError(firstNameMissingMessage.value);
      valid = false;
    }
    if (isBizNull(lastName)) {
      setLastNameError(lastNameMissingMessage.value);
      valid = false;
    }
    // if (isBizNull(email)) {
    //   setEmailError(emailMissingMessage.value);
    //   valid = false;
    // } else if (!emailIsValid) {
    //   setEmailError(emailWarningMessage.value);
    //   valid = false;
    // }
    // if (isBizNull(phoneArea)) {
    //   setPhoneAreaError(phoneAreaMissingMessage.value);
    //   valid = false;
    // }
    // if (isBizNull(phone)) {
    //   setPhoneError(phoneMissingMessage.value);
    //   valid = false;
    // } else if (!phoneIsValid) {
    //   setPhoneError(phoneWarningMessage.value);
    //   valid = false;
    // }
    if (isBizNull(street)) {
      setStreetError(streetMissingMessage.value);
      valid = false;
    }
    if (isBizNull(postalCode)) {
      setPostalCodeError(postalCodeMissingMessage.value);
      valid = false;
    } else if (!postalCodeIsValid) {
      setPostalCodeError(postalCodeWarningMessage.value);
      valid = false;
    }
    if (isBizNull(city)) {
      setCityError(cityMissingMessage.value);
      valid = false;
    }
    return valid;
  };

  const onAutocompleteLocation = address => {
    if (address.street) setStreet(address.street);
    setCity(address.city ? address.city : "");
    setPostalCode(address.postalCode ? address.postalCode : "");

    if (address.country && countries) {
      const filteredCountry = countries.filter(c => c.data.regionAbbr === address.country);
      if (filteredCountry && filteredCountry.length) {
        setCountry(filteredCountry[0]);
      }
    }
  };

  const firstNameProps = {
    label: firstNameLabel.value,
    value: firstName,
    maxLength: 25,
    showError: firstNameError !== null,
    warningMessage: firstNameError,
    disabled: isDisabled,
    onFocus: evt => {
      setFirstNameError(null);
    },
    onBlur: evt => {
      setFirstName(evt.target.value);
    }
  };
  const lastNameProps = {
    label: lastNameLabel.value,
    value: lastName,
    maxLength: 25,
    showError: lastNameError !== null,
    warningMessage: lastNameError,
    disabled: isDisabled,
    onFocus: evt => {
      setLastNameError(null);
    },
    onBlur: evt => {
      setLastName(evt.target.value);
    }
  };
  // const emailProps = {
  //   type: "email",
  //   label: emailLabel.value,
  //   value: email,
  //   showError: emailError !== null,
  //   warningMessage: emailError,
  //   disabled: isDisabled,
  //   onFocus: evt => {
  //     setEmailIsValid(true);
  //     setEmailError(null);
  //   },
  //   onChange: (evt, isValid) => {
  //     setEmailIsValid(isValid);
  //   },
  //   onBlur: evt => {
  //     setEmail(evt.target.value);
  //     if (!emailIsValid) {
  //       setEmailError(emailWarningMessage.value);
  //     }
  //   }
  // };
  // const phoneAreaProps = {
  //   type: "tel-area",
  //   label: phoneAreaLabel.value,
  //   value: phoneArea,
  //   showError: phoneAreaError !== null,
  //   warningMessage: phoneAreaError,
  //   disabled: isDisabled,
  //   onFocus: evt => {
  //     setPhoneAreaIsValid(true);
  //     setPhoneAreaError(null);
  //   },
  //   onInput: (evt, isValid) => {
  //     setPhoneAreaIsValid(isValid);
  //   },
  //   onBlur: evt => {
  //     setPhoneArea(evt.target.value);
  //   }
  // };
  // const phoneProps = {
  //   type: "tel",
  //   label: phoneLabel.value,
  //   value: phone,
  //   showError: phoneError !== null,
  //   warningMessage: phoneError,
  //   disabled: isDisabled,
  //   onFocus: evt => {
  //     setPhoneIsValid(true);
  //     setPhoneError(null);
  //   },
  //   onChange: (evt, isValid) => {
  //     setPhoneIsValid(isValid);
  //   },
  //   onBlur: evt => {
  //     setPhone(evt.target.value);
  //     if (!phoneIsValid) {
  //       setPhoneError(phoneWarningMessage.value);
  //     }
  //   }
  // };
  const streetProps = {
    label: streetLabel.value,
    value: street,
    showError: streetError !== null,
    warningMessage: streetError,
    disabled: isDisabled,
    location: { onAutocomplete: onAutocompleteLocation },
    onFocus: evt => {
      setStreetError(null);
    },
    onBlur: evt => {
      setStreet(evt.target.value);
    }
  };
  const apartmentProps = {
    label: apartmentLabel.value,
    value: apartment,
    showError: apartmentError !== null,
    warningMessage: apartmentError,
    disabled: isDisabled,
    onFocus: evt => {
      setApartmentError(null);
    },
    onBlur: evt => {
      setApartment(evt.target.value);
    }
  };
  const postalCodeProps = {
    label: postalCodeLabel.value,
    value: postalCode,
    showError: postalCodeError !== null,
    warningMessage: postalCodeError,
    disabled: isDisabled,
    onFocus: evt => {
      setPostalCodeError(null);
    },
    onBlur: (evt, isValid) => {
      setPostalCode(evt.target.value);
      setPostalCodeIsValid(isValid);
    },
    className: "right-gap"
  };
  const cityProps = {
    label: cityLabel.value,
    value: city,
    showError: cityError !== null,
    warningMessage: cityError,
    disabled: isDisabled,
    onFocus: evt => {
      setCityError(null);
    },
    onBlur: evt => {
      setCity(evt.target.value);
    }
  };
  const countryProps = {
    placeholder: countryLabel.value,
    options: countries,
    selectedOption: country,
    showError: countryError !== null,
    warningMessage: countryError,
    disabled: isDisabled,
    onChange: option => {
      setCountry(option);
      setCountryError(null);
      if (!isGlobalSite()) {
        if (option.code !== siteInfo.country) {
          setCountryPrivateImportMsgShow(true);
        } else {
          setCountryPrivateImportMsgShow(false);
        }
      } else {
        setCountryPrivateImportMsgShow(false);
      }
    }
  };
  const btnProps = ctaName && {
    buttonText: ctaName.value,
    ctaType,
    colorScheme,
    iconName,
    isDisabled: submitting,
    callback: async () => {
      setFormError(null);
      if (validateFields()) {
        setSubmitting(true);
        let action = "create";
        const body = {
          firstName: user?.firstName,
          lastName: user?.lastName,
          city: city,
          street: street,
          apartment: apartment,
          postalCode: postalCode,
          countryCode: country.data.regionAbbr,
          countryId: country.data.regionId,
          country: country.data.regionName,
          defaultFlag: "0",
          addressType: addressTypes.shipping
        };
        if (address?.addressId) {
          action = "update";
          body.addressId = address.addressId;
          body.defaultFlag = address.defaultFlag;
        }
        await api.address[action](null, body);
        if (onSaveSuccess) {
          if (address?.addressId) {
            Object.assign(address, {
              ...body,
              firstName: firstName,
              lastName: lastName
            });
            onSaveSuccess(address);
          } else {
            onSaveSuccess({
              ...body,
              firstName: firstName,
              lastName: lastName
            });
          }
        }
      }
    }
  };

  return (
    <div className="billing-info-form" ref={rootEl}>
      <Input name="first-name" automcomplete="first-name" {...firstNameProps} />
      <Input name="family-name" automcomplete="family-name" {...lastNameProps} />
      {/*<Input name="email" automcomplete="email" {...emailProps} />*/}
      {/*<div className="group">*/}
      {/*  <Input name="tel-area" automcomplete="tel-local" {...phoneAreaProps} />*/}
      {/*  <Input name="tel" automcomplete="tel-local" {...phoneProps} />*/}
      {/*</div>*/}
      <Input name="street-address" automcomplete="street-address" {...streetProps} />
      <Input {...apartmentProps} />
      <div className="group">
        <Input name="postal-code" type={/^nl-nl$/i.test(lang) ? "postalCode" : null} automcomplete="postal-code" {...postalCodeProps} />
        <Input name="city-address" automcomplete="city-address" {...cityProps} />
      </div>
      <Dropdown {...countryProps} />
      {countryPrivateImportMsgShow && <div className="private-import-message">{countryPrivateImportMessage.value}</div>}
      {formError && <div className="failed-message">{formError}</div>}
      {isLoggedIn() && savable && <SuperButton {...btnProps} />}
    </div>
  );
});
const mapStateToProps = state => ({
  user: selectUserState(state)
});
PreSalesBillingInfoForm.displayName = "PreSalesBillingInfoForm";
export default connect(mapStateToProps, null, null, { forwardRef: true })(PreSalesBillingInfoForm);
